


























































import AbpBase from "../../../lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '../../../lib/util'
import {GetWardList,GetShiftList} from '../../../api/specialDictionary'
import {GetQueueNumber,GetQueueNumberTemp,UpdateQueueNumber} from '@/api/queuingUp'
@Component({
    components:{}
})
export default class  extends AbpBase{
    @Watch('tabsValue')
    watchtabsValue(){
        this.getData()
    }
    //tabs页
    tabsValue = '1'
    queueNumber = 1
    async created() {
        await this.getWardList()
        this.getData()
        this.getTemp()
    }
    isAttention = false
    signInNo = 1
    wardId = null
    wardList = []

    list:any = []
    isActive = 0
    //获取病区
    async getWardList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetWardList(data)
        this.wardList = res.items
        this.wardId = res.items[0].id
    }
    //最低高度
    get minHeight(){
        return window.innerHeight-250
    }
    temp = ''
    //获取模板
    async getTemp(){
        let data = {
            TempType:1,
        }
        let res = await GetQueueNumberTemp(data)
        this.temp = res[0].sequenceContent
        console.log(res)
    }
    async getData(){
        let data = {
            AreaNo:this.wardId,
            IsQueueNumber:this.tabsValue=='1'?true:false,
            SignInNo:this.signInNo,
            TempType:1,
        }
        let res = await GetQueueNumber(data)
        this.list = res
    }
    async save(type:number){
        // let str = this.temp.replace(/{姓名}/,this.list[this.isActive].queueNumberContent)
        let index = type!=1?this.isActive+1:this.isActive
        if(!this.list[index]){
            return false
        }
        let res = await UpdateQueueNumber({id:this.list[index].id})
        if(res.status == 1){
            this.getData()
            for(var i = 0;i<this.queueNumber; i++ ){
                // var msg = new SpeechSynthesisUtterance('有请三病区二号床的阿黄到透析区来插管管');
                let temp = this.temp;
                temp = temp.replace(new RegExp(/{姓名}/g),this.list[index].patientName)
                temp = temp.replace(new RegExp(/{病区}/g),this.list[index].wardName)
                temp = temp.replace(new RegExp(/{床号}/g),this.list[index].bedNo)
                var msg = new SpeechSynthesisUtterance(temp);
                msg.rate = 0.3
                console.log(msg);
                window.speechSynthesis.speak(msg);
            }
        }
        
        
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/queuingUp/queueNumber/index.vue